import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Skeleton, Divider, Typography, Drawer } from "antd";
import { RestaurantRate } from "./Rate";
import { Header, MapView } from "@/components";

/**餐厅详情 */
export const Profile = ({ restaurant }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [showMap, setShowMap] = useState(false);
  return (
    <article className="page-restaurant--profile">
      {restaurant ? (
        <React.Fragment>
          <h3>{restaurant.name}</h3>
          <RestaurantRate restaurant={restaurant} showPrice={true} />
          <div className="profile-items">
            <div className="profile-openhour">
              <i className="icon icon-time"></i>
              <div className="content">
                <Typography.Paragraph ellipsis={{ rows: 2 }}>
                  {restaurant.opening_hour}
                </Typography.Paragraph>
              </div>
            </div>
            <div
              className="profile-openhour-mobile"
              data-show={show}
              onClick={() => setShow(!show)}
            >
              <i className="icon icon-time"></i>
              <div className="content">{restaurant.opening_hour}</div>
              <i className="icon icon-arrow-down"></i>
            </div>
            <Divider type="vertical" />
            <footer className="profile-footer flex">
              <div className="profile-address inline-flex" onClick={() => setShowMap(true)}>
                <i className="icon icon-location"></i>
                <span>{restaurant.address}</span>
              </div>
              <Divider type="vertical" />
              <a
                className="icon icon-phone"
                href={`tel:${restaurant.phone}`}
              ></a>
            </footer>
          </div>
        </React.Fragment>
      ) : (
        <Skeleton />
      )}
      <Drawer
        className="restaurant-drawer"
        placement="right"
        closable={false}
        destroyOnClose
        onClose={() => setShowMap(false)}
        visible={showMap}
      >
        <Header title={t("ADDRESS")} onClick={() => setShowMap(false)} />
        {/* 地图 */}
        <div className="restaurant-map">
          <MapView {...restaurant} showButton={true} />
        </div>
      </Drawer>
    </article>
  );
};
